"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mappers_1 = require("../mappers");
const models_1 = require("../models");
const OrganizationUser_1 = __importDefault(require("../organizationuser/OrganizationUser"));
const AllSocketsManager_1 = require("../socket/AllSocketsManager");
class User {
    constructor(authAdapter, config, httpAdapter, adapterFactory) {
        this.authAdapter = authAdapter;
        this.config = config;
        this.httpAdapter = httpAdapter;
        this.adapterFactory = adapterFactory;
        this.orgUsers = undefined;
        this.activeOrgUsers = [];
        this.socketManager = new AllSocketsManager_1.AllSocketsManager(this);
    }
    getSocketManager() {
        return this.socketManager;
    }
    getActiveOrgUsers() {
        return this.activeOrgUsers;
    }
    isAuthenticated() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.authAdapter.isAuthenticated();
        });
    }
    disconnectSockets() {
        return __awaiter(this, void 0, void 0, function* () {
            for (const orgUser of this.activeOrgUsers) {
                yield orgUser.getSocketManager().disconnect();
            }
        });
    }
    logOut() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.destroyOrgUsers();
            yield this.authAdapter.logOut();
        });
    }
    destroyOrgUsers() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.orgUsers) {
                yield Promise.all(this.orgUsers.map(orgUser => orgUser.destroy()));
            }
        });
    }
    fetchOrganizations(internetStatusManager) {
        return __awaiter(this, void 0, void 0, function* () {
            const orgsData = (0, mappers_1.organizationMapper)(yield this.httpAdapter.getOrganizationAdapter().getOrganizations());
            this.orgUsers = yield Promise.all(orgsData
                .sort((orgDataA, orgDataB) => orgDataB.organizationStatus === models_1.ORGANIZATION_STATUS.ACTIVE
                ? orgDataB.userProfile.status !== models_1.USER_STATUS.ACTIVE
                    ? -1
                    : 1
                : -1)
                .map((orgData) => __awaiter(this, void 0, void 0, function* () {
                const orgUser = new OrganizationUser_1.default(orgData, this.config, this.adapterFactory, this.authAdapter, internetStatusManager);
                yield orgUser.init();
                return orgUser;
            })));
            this.activeOrgUsers = this.orgUsers.filter(org => org.isOrganizationActive());
        });
    }
    getOrganizations() {
        return this.orgUsers;
    }
    getActiveOrganizations() {
        return this.activeOrgUsers;
    }
    getTotalBadgeCount() {
        var _a, _b;
        return ((_b = (_a = this.getOrganizations()) === null || _a === void 0 ? void 0 : _a.reduce((total, orgUser) => total + orgUser.getOrganization().badgeCount, 0)) !== null && _b !== void 0 ? _b : 0);
    }
    getOrganizationById(orgId) {
        var _a;
        return (_a = this.orgUsers) === null || _a === void 0 ? void 0 : _a.find(orgUser => orgUser.isOrganization(orgId));
    }
}
exports.default = User;
